import React, { useState } from "react";

const IndianInputMasking = ({ placeholder = "Enter a number..." }) => {
  const [value, setValue] = useState("");

  // Function to format numbers in the Indian numbering system
  const formatIndianNumber = (num) => {
    let x = num.replace(/\D/g, ""); // Remove non-numeric characters
    let lastThree = x.substring(x.length - 3);
    let otherNumbers = x.substring(0, x.length - 3);
    if (otherNumbers !== "") {
      lastThree = "," + lastThree;
    }
    return otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ",") + lastThree;
  };

  // Handle input changes and apply Indian number formatting
  const handleInputChange = (e) => {
    const input = e.target.value;
    setValue(formatIndianNumber(input));
  };

  return (
    <div>
      <label className="form-label">Input Masking (Indian Format)</label>
      <input
        type="text"
        value={value}
        onChange={handleInputChange}
        placeholder={placeholder}
        className="number-input form-control input-lg"
      />
    </div>
  );
};

export default IndianInputMasking;
